// extracted by mini-css-extract-plugin
export default {"main":"d9eae4b896 c387937ee0 _29ef384c4c _64e8ad3ca7","title":"faef7ec874"};